import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;
export const insertUserReturnEntry = createAsyncThunk('insertUserReturnEntry', async (postData) => {
    //console.log("postdata=>",postData);
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertUserReturnEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchUserReturnData = createAsyncThunk('fetchUserReturnData', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=getUserReturnData`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});
export const deleteUserReturn = createAsyncThunk('deleteUserReturn', async (id) => {
    const { userId, usId } = id;
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteUserReturnEntry&usId=${usId}&userId=${userId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateUserReturnEdit = createAsyncThunk('updateUserReturnEdit', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=updateUserReturnEdit`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertUserStkRtInwEntry = createAsyncThunk('insertUserStkRtInwEntry', async (postData) => {
   // console.log("postdata=>",FormData.postData);
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertSchlStockRtInw`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});
export const fetchUserStkRtInwData = createAsyncThunk('fetchUserStkRtInwData', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=fetchUserStkRtInwData`, postData);
       console.log("API raw response =>", response.data);  
        return response.data;
    } catch (error) {
        throw error;
    }
});
// Slice

const userReturnSlice = createSlice({
    name: 'UserReturnData',
    initialState: {
        isLoading: false,
        isError: false,
        userReturnData: null,
        userStkRtInwData: null,
        insertResponse: null,
        updateResponse: null,
        deleteResponse: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUserReturnData.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchUserReturnData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.userReturnData = action.payload;
        });
        builder.addCase(fetchUserReturnData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchUserStkRtInwData.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchUserStkRtInwData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ustkdata  = action.payload;
        });
        builder.addCase(fetchUserStkRtInwData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(insertUserReturnEntry.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(insertUserReturnEntry.fulfilled, (state, action) => {
            state.isLoading = false;
            state.insertResponse = action.payload;
        });
        builder.addCase(insertUserReturnEntry.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(updateUserReturnEdit.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(updateUserReturnEdit.fulfilled, (state, action) => {
            state.isLoading = false;
            state.updateResponse = action.payload;
        });
        builder.addCase(updateUserReturnEdit.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteUserReturn.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(deleteUserReturn.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteResponse = action.payload;
        });
        builder.addCase(deleteUserReturn.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(insertUserStkRtInwEntry.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(insertUserStkRtInwEntry.fulfilled, (state, action) => {
            state.isLoading = false;
            state.insertResponse = action.payload;
        });
        builder.addCase(insertUserStkRtInwEntry.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default userReturnSlice.reducer;
